import * as React from 'react';
export const demopaySvg = React.forwardRef(function demopaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#B48E41',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M17.5 27c5.9-.4 10.5-5.2 10.5-11S23.4 5.4 17.5 5v3c3 .3 4.7 2 5 4.4h-3.2c-.3-1.1-1.4-2-3-2-1.8.1-2.9.8-2.9 2 0 1 .8 1.6 2.7 2l1.7.3c3.5.7 5 2 5 4.4 0 2.8-2 4.6-5.3 5V27Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M16.8 27H9a2 2 0 0 1-2-2V7c0-1.1 1-2 2-2h5.5v3c-2.7.5-4.4 2.2-4.4 4.6 0 2.4 1.4 3.9 4.8 4.6l1.7.3c2 .4 2.8 1 2.8 2 0 1.2-1.3 2-3 2-2 0-3.3-.8-3.4-2H9.7v.1c.2 2.3 2 4 4.8 4.4v3h2.3Z',
    }),
  );
});
demopaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var demopay = {
  category: 'brand',
  colorable: false,
  name: 'demopay',
  svg: demopaySvg,
};
